<template>
  <base-content>
    <template v-slot:top>
      <project-heading back>Project Details</project-heading>
    </template>
    <template v-if="loaded">
      <form @submit.prevent="submit">
        <project-details v-model="payload" />
        <base-card>
          <template v-slot:header>
            <base-card-heading>Confirmation</base-card-heading>
          </template>
          <p>
            I confirm that the information given is true, accurate and not misleading and acknolwedge
            that the information will be used to form our assessment of any requests for loans and
            we may therefore rely on any statement provided.
          </p>
          <div class="text-right">
            <base-button icon-right="arrow-right" :loading="saving" primary submit>
              Save Details
            </base-button>
          </div>
        </base-card>
      </form>
      <project-add-supporting-document />
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import ProjectAddSupportingDocument from '@/components/ProjectAddSupportingDocument.vue'
import ProjectDetails from '@/components/ProjectDetails.vue'
import ProjectHeading from '@/components/ProjectHeading.vue'

export default {
  async created () {
    await this.$store.dispatch('core/projects/get', this.$route.params.id)

    this.payload = this.$_.cloneDeep(this.$_.omit(this.project, 'documents'))
    this.payload.stages.details = true

    this.loaded = true
  },

  data () {
    return {
      payload: {},
      loaded: false,
      saving: false
    }
  },

  components: {
    ProjectAddSupportingDocument,
    ProjectDetails,
    ProjectHeading
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/projects/save', this.payload)

      this.$flash.success('Project details successfully saved.')

      this.$router.push({ name: 'projects.dashboard', params: { id: this.project._id } })
    }
  }
}
</script>
